<template>
  <div class="app-container">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span><i class="el-icon-s-check"></i> 用章审批</span>
      </div>

      <!-- 搜索区域 -->
      <el-form
        :model="queryParams"
        label-position="right"
        label-width="70px"
        class="demo-form-inline"
        style="margin-bottom: 20px"
      >
        <el-row :gutter="20">
          <!-- 申请部门 -->
          <el-col :xs="24" :sm="12" :md="8" :lg="6">
            <el-form-item label="申请部门">
              <el-select
                v-model="queryParams.departmentName"
                placeholder="请选择申请部门"
                clearable
                style="width: 100%"
              >
                <el-option
                  v-for="item in departmentList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.name"
                />
              </el-select>
            </el-form-item>
          </el-col>

          <!-- 申请人 -->
          <el-col :xs="24" :sm="12" :md="8" :lg="6">
            <el-form-item label="申请人">
              <el-input
                v-model="queryParams.creatorName"
                placeholder="请输入申请人"
                clearable
                style="width: 100%"
              />
            </el-form-item>
          </el-col>

          <!-- 状态 -->
          <el-col :xs="24" :sm="12" :md="8" :lg="6">
            <el-form-item label="审批状态">
              <el-select
                v-model="queryParams.state"
                placeholder="请选择审批状态"
                clearable
                style="width: 100%"
              >
                <el-option
                  v-for="item in statusOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
          </el-col>

          <!-- 用章名称 -->
          <el-col :xs="24" :sm="12" :md="8" :lg="6">
            <el-form-item label="用章名称">
              <el-select
                v-model="queryParams.stampTypeName"
                placeholder="请选择用章名称"
                clearable
                style="width: 100%"
              >
                <el-option
                  v-for="item in typeList"
                  :key="item.name"
                  :label="item.name"
                  :value="item.name"
                />
              </el-select>
            </el-form-item>
          </el-col>

          <!-- 时间 -->
          <el-col :xs="24" :sm="12" :md="8" :lg="6">
            <el-form-item label="用章时间">
              <el-date-picker
                v-model="queryParams.applyTimeRange"
                type="daterange"
                align="right"
                unlink-panels
                start-placeholder="开始时间"
                end-placeholder="结束时间"
                value-format="yyyy-MM-dd"
                clearable
                style="width: 100%"
              />
            </el-form-item>
          </el-col>
        </el-row>

        <!-- 按钮区域保持不变 -->
        <div>
          <el-button
            type="primary"
            icon="el-icon-search"
            @click="handleQuery(1)"
          >
            搜索
          </el-button>
          <el-button @click="resetQuery">重置</el-button>
          <el-button @click="handleExport">导出</el-button>
        </div>
      </el-form>

      <!-- 表格 -->
      <el-table
        :data="tableData"
        style="width: 100%"
        border
        :cell-style="{ textAlign: 'center' }"
        :header-cell-style="{
          background: '#f5f7fa',
          color: '#333',
          fontWeight: 'bold',
          textAlign: 'center',
        }"
      >
        <el-table-column
          prop="departmentName"
          label="申请部门"
          width="150"
          fixed
        ></el-table-column>
        <el-table-column
          prop="creatorName"
          label="申请人"
          width="120"
          fixed
        ></el-table-column>
        <el-table-column
          prop="stampTypeName"
          label="用章名称"
          width="120"
          fixed
        ></el-table-column>
        <el-table-column
          prop="useStampDate"
          label="使用时间"
          width="160"
        ></el-table-column>
        <el-table-column
          prop="reason"
          label="用章事由"
          min-width="200"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column label="是否外借" width="120">
          <template slot-scope="scope">
            <el-tag :type="scope.row.loanFlag ? 'success' : 'info'">
              {{ scope.row.loanFlag ? "是" : "否" }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column
          label="归还时间"
          prop="returnDate"
          width="160"
        ></el-table-column>
        <el-table-column prop="state" label="状态" width="120">
          <template slot-scope="scope">
            <el-tag
              :type="
                [1, 14].includes(scope.row.state)
                  ? 'success'
                  : [0, 13].includes(scope.row.state)
                  ? 'warning'
                  : 'danger'
              "
            >
              {{ STAMP_STATUS_MAP[scope.row.state] }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column
          prop="approverName"
          label="审批人"
          width="120"
        ></el-table-column>
        <el-table-column
          prop="levelCCApprover"
          label="抄送给"
          width="150"
        ></el-table-column>
        <el-table-column
          prop="rejectReason"
          label="驳回信息"
          width="180"
        ></el-table-column>
        <el-table-column
          prop="createTime"
          label="发起时间"
          width="160"
        ></el-table-column>
      </el-table>

      <!-- 分页 -->
      <pagination-bar
        :total="total"
        :page-size="pageSize"
        :current-page="currentPage"
        @update:pageSize="pageSize = $event"
        @update:currentPage="currentPage = $event"
        @page-change="handleQuery"
      />
    </el-card>
  </div>
</template>

<script>
import { stampApplicationPage, stampApplicationExport } from "@/api/admin";
import { departmentList, stampTypeList } from "@/api/config.js";
import { MAX_PAGE_SIZE, STAMP_STATUS } from "@/utils/const.js";
import {
  listToMap,
  parseDateRange,
  downloadFile,
  formatTime,
} from "@/utils/util";
import PaginationBar from "@/components/PaginationBar";
import { omit } from "lodash";
import { mapState } from "vuex";

const STAMP_STATUS_MAP = listToMap(STAMP_STATUS);
export default {
  name: "StampApproval",
  components: { PaginationBar },
  computed: {
    ...mapState(["departmentList"]), // 从 Vuex 获取 userPermissions
  },
  data() {
    return {
      selectedRows: [],
      total: 100,
      pageSize: 10,
      currentPage: 1,
      // 查询参数
      queryParams: {
        name: "",
        department: "",
        stampTypeName: "",
        state: "",
        applyTimeRange: [],
      },
      // 表格数据
      tableData: [],
      typeList: [],
      statusOptions: STAMP_STATUS,
      STAMP_STATUS_MAP,
    };
  },
  created() {
    this.handleQuery(1);
    this.getTypeList();
  },
  methods: {
    getTypeList() {
      stampTypeList({
        pageNo: 1,
        pageSize: MAX_PAGE_SIZE,
      }).then((res) => {
        this.typeList = res.records;
      });
    },
    // 导出方法
    handleExport() {
      const exportData = this.tableData || [];

      if (exportData.length === 0) {
        return this.$message.warning("暂无数据可以导出");
      }

      const { begin_date, end_date } = parseDateRange(
        this.queryParams.applyTimeRange
      );
      const params = omit(this.queryParams, ["applyTimeRange"]);
      stampApplicationExport({
        pageNo: this.currentPage,
        pageSize: this.pageSize,
        startUseStampDate: begin_date ? formatTime(begin_date) : "",
        endUseStampDate: end_date ? formatTime(end_date) : "",
        ...params,
      }).then((res) => {
        downloadFile(
          res.data,
          "用章审批数据.xlsx",
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        );
      });
    },
    // 搜索
    handleQuery(page) {
      this.currentPage = page || 1;

      const { begin_date, end_date } = parseDateRange(
        this.queryParams.applyTimeRange
      );

      const params = omit(this.queryParams, ["applyTimeRange"]);
      stampApplicationPage({
        pageNo: this.currentPage,
        pageSize: this.pageSize,
        startUseStampDate: begin_date ? formatTime(begin_date) : "",
        endUseStampDate: end_date ? formatTime(end_date) : "",
        ...params,
      }).then((res) => {
        this.tableData = res.records;
        this.total = res.total;
      });
    },
    // 重置搜索
    resetQuery() {
      this.queryParams = {
        name: "",
        department: "",
        type: "",
        days: undefined,
      };
      this.handleQuery(1);
    },
  },
};
</script>

<style lang="scss" scoped>
.app-container {
  .el-icon-s-check {
    margin-right: 5px;
    font-size: 18px;
  }

  .el-table {
    .el-icon-user,
    .el-icon-document,
    .el-icon-time,
    .el-icon-notebook-2 {
      margin-right: 5px;
    }
  }

  .el-tag {
    .el-icon-check,
    .el-icon-loading,
    .el-icon-close {
      margin-right: 5px;
    }
  }

  .el-button {
    .el-icon-edit,
    .el-icon-delete,
    .el-icon-plus,
    .el-icon-close,
    .el-icon-check {
      margin-right: 5px;
    }
  }

  .el-select {
    .el-icon-document,
    .el-icon-document-checked,
    .el-icon-money {
      margin-right: 5px;
    }
  }
}
</style>
